export default __webpack_public_path__ + "static/media/Foto20.530c8e17.png";